
import { RevIllustration } from '@ds/components/Illustration'
import { RevModal } from '@ds/components/Modal'
import { IconClock } from '@ds/icons/IconClock'
import { IconRefund } from '@ds/icons/IconRefund'
import { IconThumbsDownOutlined } from '@ds/icons/IconThumbsDownOutlined'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'

import translationsTrustList from '../TrustList/TrustList.translations'

import translations from './SatisfactionModal.translations'

export default {
  components: {
    FormattedMessage,
    IconRefund,
    IconClock,
    IconThumbsDownOutlined,
    RevIllustration,
    RevModal,
  },

  props: {
    name: {
      type: String,
      default: MODAL_NAMES.REASSURANCE.SATISFACTION,
    },
  },

  computed: {
    translations: () => translations,

    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
    }),

    showReturnsLine() {
      return this.$t(translations.returnTitle)
    },

    showPaymentsLine() {
      return this.$t(translations.paymentTitle)
    },

    title() {
      return this.$t(translationsTrustList.satisfaction, {
        days: this.coolingOffDays,
      })
    },
  },
}
